import { useMutation } from '@apollo/client';
import { loader } from 'graphql.macro';

const update = loader('./attachments.update.graphql');
const add = loader('./attachments.add.graphql');
const archive = loader('./attachments.delete.graphql');

export const useAttachmentMutations = () => {
  const [updateAttachmentMutation] = useMutation(update);
  const [addAttachmentMutation] = useMutation(add);
  const [deleteAttachmentMutation] = useMutation(archive);
  const updateAttachment = async (variables) => {
    await updateAttachmentMutation({
      variables: { ...variables },
    });
  };

  const addAttachment = async (variables) => {
    return addAttachmentMutation({
      variables: { ...variables },
    });
  };
  const deleteAttachment = async ({ id }) => {
    await deleteAttachmentMutation({ variables: { id } });
  };

  return { updateAttachment, addAttachment, deleteAttachment };
};
